import Axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

const api = Axios.create({
  baseURL: process.env['NEXT_PUBLIC_API_URL'],
  // baseURL: 'https://deliveries-stage.scapespec.co.nz/',
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    accept: 'application/json',


  },
  withCredentials: true,
});

api.interceptors.request.use(
  async (config) => {
    let token = null;

    try {
      token = localStorage.getItem('token');

    } catch (err) {
      if (err instanceof ReferenceError) {
        // use React Native AsyncStorage
        token = await AsyncStorage.getItem('@token');

        const url = (await AsyncStorage.getItem('@url')) ?? undefined;

        if (url) {
          config.baseURL = url;
        }
      } else {
        throw err;
      }
    }

    if (token && config.headers) {
      config.headers.authorization = `Bearer ${token}`;
    }

    const cfClientId = process.env['NEXT_PUBLIC_CF_ACCESS_CLIENT_ID'];
    const cfClientSecret = process.env['NEXT_PUBLIC_CF_ACCESS_CLIENT_SECRET'];
    if (cfClientId && cfClientSecret && config.headers) {
      config.headers['CF-Access-Client-Id'] = cfClientId;
      config.headers['CF-Access-Client-Secret'] = cfClientSecret;
    }

    return config;
  },
  (error) => Promise.reject(error)
);



api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default api;
